import ApiService from '@api/api-service';
import PaymentiFrame from '../vendor/bluefin';
import AjaxLoader from './ajax-loader/ajax-loader';
import store from '@stores/cart/cart-store';
import CheckoutAddressForm, { DEFAULT_OPTIONS as addressFormDefaults } from './checkout/checkout-address-form-cc';
import { context as defaultContext } from './checkout/checkout-defaults';
import SelectBox from './select-box/select-box';
import shippingService from '@api/routes/cart/getshippinginformation';
import isFn from '@utils/is-function';


const CLASS_NAME_ADD_ADDRESS_DISABLED = '-disabled';
const CLASS_NAME_ADD_METHOD_DISABLED = '-disabled';
const CLASS_NAME_REVIEW_BUTTON_DISABLED = 'disabled';

const NEW_ADDRESS_OPTION_VALUE = '__checkoutBilling_newAddress__';

const DEFAULT_OPTIONS = {
    addPaymentFormClassList: '',
    classList: '',
    onCancelHandler: null,
    onCancelBillHandler: null,
    replaceOriginEl: false
};

const DEFAULT_LOADER_OPTIONS = {
    aria: false,
    className: 'd-flex align-items-center h-100',
    size: 'xs',
    visible: true
};

export default class AddPaymentWithaddress {
    constructor(options, context) {
        context = { ...defaultContext, ...context };
        this.options = options;
        this.api = new ApiService(options.urlPath);

        this.loader = null;

        this.initializeElements();
        if (!this.frameSettings || this.$paymentFrame.length) {
            return true
        }

        this.setupLoader();
        this.setupFrame();
        this.setEvents();
        this.setScrolling();
        this.renderCheckoutForm();
        this.renderSelectors();
        this.getShippingAddress();
        this.setupListeners();
    }

    initializeElements() {
        this.$container = $(this.options.containerId);
        this.$formContainer = this.$container.find('[data-region="addressForm"]');
       // this.$form = this.$container.find('[data-control="form"]');
       this.$frameSettings = $('#paymentSettings');
       //console.log('settings' ,this.$frameSettings );
        this.$paymentLoader = this.$container.find(this.options.paymentLoaderId);
        this.$savePayment = this.$container.find(this.options.savePaymentId);
        this.$savePaymentError = this.$container.find(this.options.savePaymentErrorId);
        this.$updateAutoshipCheckbox = this.$container.find(this.options.updateAutoshipCheckboxId);
        this.$paymentFormPlaceholder = $(this.options.formId);
        this.$addressPlaceholder = $('#addPaymentContainer').find('[data-placeholder="address"]');
        this.addressSelector = null;
        this.disableServiceUpdate = false;
        this.$addAddressCtrl = this.$container.find('[data-control="addAddress"]');
        this.newAddress = {};
        this.$methodForm = this.$container.find('[data-region="methodForm"]');
        this.shippingAddress = {};
        this.$select = null;

        if (this.$frameSettings.length) {
            this.frameSettings = JSON.parse(this.$frameSettings.html());
            this.$paymentFrame = this.$container.find('#' + this.frameSettings.iframeId);
        }
    }

    setupListeners() {
        this.$addAddressCtrl.on('click', () => this.onAddAddressClick());
        this.$select.on('change', evt => this.onSelectChange(evt));
       // this.checkoutForm.watchValue((value) => this.onCheckoutFormUpdate(value));
    }

    onSelectChange(evt){
        const value = evt.target.value;
        //console.log(value);
        let addresses = this.addresses;
        let billingParty = addresses.find((address) => address.AddressName === value);
        //console.log('billp3', billingParty);
        store.mutations.SET_BILLING_PARTY(billingParty);
    }

    
    onAddressFormCancel() {
        this.$methodForm.slideUp('fast');
        this.addressSelector.enable();
        this.addressSelector.enableElement();
        this.$addAddressCtrl.removeAttr('aria-expanded');

      //  this.addressFormVisible = false;
    }

    onAddAddressClick() {


        if (this.loading) return;
        if(this.$methodForm.css('display') == 'block'){
                this.$methodForm.slideUp('fast');
                this.addressSelector.enable();
                this.addressSelector.enableElement();
                this.$addAddressCtrl.removeAttr('aria-expanded');
        }else{
            this.addressSelector.disableElement();
            this.$methodForm.slideDown('fast');
            this.$addAddressCtrl.attr('aria-expanded', true);
        }

        this.newAddress = {};
        this.checkoutForm.setValues({
            firstName: '',
            lastName: '',
            address: '',
            address2: '',
            city: '',
            state: '',
            zip: ''
        });

        const options = [...this.addressOptions];
     //   const newAddressOption = { text: this.context.NewAddress, value: NEW_ADDRESS_OPTION_VALUE };
        const newAddressIndex = options.findIndex(({ value }) => value === NEW_ADDRESS_OPTION_VALUE);

        if (newAddressIndex > -1) {
            options[newAddressIndex] = newAddressOption;
        } else {
          //  options.push(newAddressOption);
        }

        this.addressOptions = options;

        this.updateUiOnly(() => {
      //      this.addressSelector.setValue(NEW_ADDRESS_OPTION_VALUE);
        });

        this.addressSelector.disableElement();
    }

    parseAddressText(address) {
        let text = address.Address1;

        if (address.Address2) {
            text += ` ${address.Address2}`;
        }

        text += ` ${address.City}, ${address.StateCode} ${address.ZipPostalCode}`;

        return text;
    }

    mapAddressOptions(addresses = []) {
        this.addresses = addresses;

        const addressOptions =
            addresses
                .filter((address) => address !== null && address !== undefined && address.AddressName !== this.shippingAddressId)
                .map((address, index) => {
                    const text = this.parseAddressText(address);
                    return {
                        text,
                        value: address.AddressName
                    };
                });

                const options = {
                    options:addressOptions
                };

        this.addressOptions = addressOptions;
        this.addressSelector.setOptions(options);
        this.addressSelector.enable();
    }

    setInitialAddress() {
        /* if (this.addressOptions.find(({ value }) => value === store.getters.billingPartyId)) {
            this.addressSelector.setValue(store.getters.billingPartyId);
            return;
        } */

        if (this.addressOptions.length > 0) {
            this.addressSelector.setValue(this.addressOptions[0].value);
        } else {
          //  this.$edit.hide();
          //  this.onAddAddressClick();
        }
    }

    setupAddresses(data) {
        const addresses = data.ShippingAddresses;
        const billingParty = addresses.find((address) => address.AddressName === data.AddressId);
        //console.log('billp1', billingParty);
        this.shippingAddress = billingParty;
        store.mutations.SET_BILLING_PARTY(billingParty);
      //  console.log('billingParty', billingParty);
      let isPrimaryIndex = addresses.findIndex(address => address.IsPrimary == true );
      addresses.unshift(addresses.splice(isPrimaryIndex, 1)[0]);
        this.mapAddressOptions(addresses);

        this.setInitialAddress();
    }

    updateUiOnly(callback) {
        if (!isFn(callback)) return;

        this.disableServiceUpdate = true;
        callback();
        this.disableServiceUpdate = false;
    }

    async getShippingAddress() {


        const { data, error, success, shippingAddressId } = await shippingService.get();

        if (success) {
            this.updateUiOnly(() => {
                this.setupAddresses(data);
            });



          //  this.addPaymentForm.setAddressId(this.selectedAddressValue);
        } else {
            this.$error.show().html(error);
        }

        this.addressesLoading = false;
        this.methodsLoading = false;
        this.loading = false;
    }

    renderSelectors() {
        this.addressSelector = new SelectBox(this.$addressPlaceholder, {
            id: this.addressId
        });
        this.addressSelector.disable();
        this.addressSelector.render();
        this.$select =  this.$container.find('.select-box__select');
    }

    renderCheckoutForm() {
        const defaultSchema = { ...addressFormDefaults.schema }
        const schema = {
            cardHolderName:{
                ...defaultSchema.cardHolderName,
                name: 'CardHolderName',
            },
            firstName: {
                ...defaultSchema.firstName,
                name: 'FirstName'
            },
            lastName: {
                ...defaultSchema.lastName,
                name: 'LastName'
            },
            address: {
                ...defaultSchema.address,
                name: 'Address1'
            },
            address2: {
                ...defaultSchema.address2,
                name: 'Address2'
            },
            city: {
                ...defaultSchema.city,
                name: 'City'
            },
            state: {
                ...defaultSchema.state,
                name: 'StateCode'
            },
            zip: {
                ...defaultSchema.zip,
                name: 'ZipPostalCode'
            }
        };

        const options = {
            onCancelHandler: () => this.onAddressFormCancel(),
            onCancelBillHandler: () => this.onAddressFormCancel(),
            replaceOriginEl: true,
            schema
        };

        const context = {
            /* cancel: this.context.Cancel,
            heading: this.context.AddBillingAddress,
            requiredToken: this.context.RequiredToken,
            submit: this.context.ApplyUpdates,
            validation: this.context.ValidationMessage */
        };


        this.checkoutForm = new CheckoutAddressForm(this.$paymentFormPlaceholder, options, context);
        this.checkoutForm.init();
        this.checkoutForm.render();
    }

    async savePaymentMethod(res, params) {
        let dstransid = '';
        let authenticationvalue = '';
        if (res.ddds_result != null) {
            if (res.ddds_result.ddds_status == 'N') {
                alert("Unable to validate payment method. Please check card number, expiration date or CVV");
                return;
            }

            //if (res.ddds_result.ddds_challenged) {
                if (res.ddds_result.ddds_dstransid != null) {
                    dstransid = res.ddds_result.ddds_dstransid;
                }
                if (res.ddds_result.ddds_authenticationvalue != null) {
                    authenticationvalue = res.ddds_result.ddds_authenticationvalue;
                }
            //}
        }
        const { success, data, error } = await this.api.post({
            //AddressId: this.options.addressId,
            Id:res.id,
            eToken: res.eToken,
            DddsAmexDsTransId: res.ddds_result.amexDsTransId,
            DddsAttempted:res.ddds_result.ddds_attempted,
            DddsAuthenticationValue: res.ddds_result.ddds_authenticationvalue,
            DddsChallenged:res.ddds_result.ddds_challenged,
            DddsDsTransId: res.ddds_result.ddds_dstransid,
            DddsEci: res.ddds_result.ddds_eci,
            DddsStatus: res.ddds_result.ddds_status,
            DddsVersion: res.ddds_result.ddds_version,
            DeliveryTimeFrame: params.ddds_params.deliveryTimeFrame,
            ReOrderItemsInd: params.ddds_params.reorderItemsInd,
            ShipIndicator: params.ddds_params.shipIndicator,
            ScaIndicator:res.ddds_result.scaIndicator,
            AcsTransId:res.ddds_result.acsTransId,
            CardBrand:res.ddds_result.card_brand,
            CardHolderName:params.ddds_params.cardHolderName,
            BillingAddressLine1:params.ddds_params.billingLine1,
            BillingAddressLine2:params.ddds_params.billingLine2,
            BillingCity: params.ddds_params.billingCity,
            BillingState: params.ddds_params.billingState,
            BillingZip: params.ddds_params.billingPostCode,
            BillingCountry: params.ddds_params.billingCountry
        });

        if(success) {
            window.location.href = window.location.href;
        } else if(error) {
            this.setError(error);
        }

        if(this.loader) this.loader.active = false;
    }

    setupLoader() {
        if(this.$paymentLoader.length) {
            this.loader = new AjaxLoader(this.$paymentLoader, {
                replaceOriginEl: false,
                size: 'xs'
            });

            this.loader.render();
        }
    }

    setupFrame() {
        this.frame = new PaymentiFrame(this.frameSettings);
    }

    setError(error) {
        if(this.$savePaymentError.length) {
            this.$savePaymentError.show().html(error);
        } else {
            alert(error);
        }
    }

    setEvents() {
        let params = {
			'ddds_params': {
                amount: "0.01",
                cardHolderName: "", //First Name + Last Name
                billingLine1: "",
                billingLine2: "",
                billingLine3: "",
                billingPostCode: "",
                billingCity: "",
                billingState: "",
                billingCountry: "840",  // ISO 3166-1 three-digit country codes. e.g. 840 for the United States
                shipIndicator: "01",
                deliveryTimeFrame: "04",
                reorderItemsInd: "01",
                shipIndicator: "01"
            }
		}


        this.$savePayment.on('click', () => {
            this.$savePaymentError.hide();

            if(this.loader) this.loader.active = true;
            let cardNameInput = $('#addPaymentContainer [data-control="cardHolderName"]');
            let cardNameError = $('#addPaymentContainer [data-region="cardHolderNameError"]');
            if(!cardNameInput[0].checkValidity()) {
                cardNameError.addClass('-visible');
                cardNameInput.parent().addClass('was-validated');
                cardNameInput.attr({ 'aria-invalid': true }).trigger('focus');
                return;
            }
            else {
                cardNameError.removeClass('-visible');
                cardNameInput.parent().removeClass('was-validated');
                cardNameInput.removeAttr('aria-invalid');
                params.ddds_params.cardHolderName = $('#addPaymentContainer [data-control="cardHolderName"]').val();
            }



            let form = this.$container.find('[data-control="form"]');
            if(this.$methodForm.css('display') == 'none'){
                params.ddds_params.billingLine1 = store.getters.billingPartyAddress1;
                params.ddds_params.billingLine2 =store.getters.billingPartyAddress2;
                params.ddds_params.billingState = store.state.billingParty.StateCode;
                params.ddds_params.billingPostCode = store.getters.billingPartyZipPostalCode;
                params.ddds_params.billingCity = store.getters.billingPartyCity;
            }else{
                //console.log('display show');
                form.trigger( "submit" );

                if(!form.hasClass('was-validated')){
                    //console.log('was vall');

                    let newbillingParty = {
                        'Address1': $('#addPaymentContainer .checkout-address-form [data-control="address"]').val(),
                        'Address2': $('#addPaymentContainer .checkout-address-form [data-control="address2"]').val(),
                        'AddressName': "",
                        'City': $('#addPaymentContainer .checkout-address-form [data-control="city"]').val(),
                        'Country': "United States",
                        'CountryCode': "US",
                        'Email': null,
                        'FirstName': "",
                        'LastName': "",
                        'Name': "",
                        'State': "",
                        'StateCode': $('#addPaymentContainer .checkout-address-form [data-control="select"]').data('value'),
                        'ZipPostalCode': $('#addPaymentContainer .checkout-address-form [data-control="zip"]').val()
                    }
                    params.ddds_params.billingLine1 = $('#addPaymentContainer .checkout-address-form [data-control="address"]').val();
                    params.ddds_params.billingLine2 = $('#addPaymentContainer .checkout-address-form [data-control="address2"]').val();
                    params.ddds_params.billingCity = $('#addPaymentContainer .checkout-address-form [data-control="city"]').val();
                    params.ddds_params.billingState = $('#addPaymentContainer .checkout-address-form [data-control="select"]').data('value');
                    params.ddds_params.billingPostCode = $('#addPaymentContainer .checkout-address-form [data-control="zip"]').val();

                    store.mutations.SET_BILLING_PARTY(newbillingParty);
                    //console.log('new bill', store.state.billingParty);
                }else{
                    //console.log('not vall');
                    this.loader.active = false;
                    return
                }
            }
          console.log('bluefin params', params);

          if(params.ddds_params.billingLine2 === null){
            params.ddds_params.billingLine2 = "";
          }


            this.frame.encrypt(params)
                .failure((error) => {
                    const message = error?.message;
                    message ? this.setError(message) : alert('Failure:', error);

                    if(this.loader) this.loader.active = false;
                })
                .invalidInput((data) => {
                    const inputs = data?.invalidInputs;
                    if(inputs.length) {
                        const messages = inputs.map((input) => input.message);
                        this.setError(messages[0]);
                    } else {
                        alert('Invalid Input:', data);
                    }

                    if(this.loader) this.loader.active = false;
                })
                .success((res) => {
                    console.log('PayConnect responce', res);
                    console.log('address params', params);
                    if (res.eToken.length > 0) {
                        this.savePaymentMethod(res, params);
                    }
                });
        });
    }

    setScrolling() {
        $('#' + this.frameSettings.iframeId).attr("scrolling", "no");
    }
}
